import { Button } from '@ktag/styleguide/dist/react';
import React from 'react';

interface ExpandButtonProps {
  onClick: () => void;
  expanded: boolean;
}

const ExpandButton = ({ expanded, onClick }: ExpandButtonProps) => {
  return (
    <Button onClick={onClick} additionalClassNames="expand-button">
      <span className={expanded ? 'minus' : 'plus'} />
    </Button>
  );
};

export default ExpandButton;
